import type { AnyRouter } from '../router'

export function getScrollRestorationScriptForRouter(_router: AnyRouter) {
  return null
}
